"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotFound = void 0;
var _react = _interopRequireDefault(require("react"));
var _notFoundModule = _interopRequireDefault(require("./not-found.module.scss"));
var _useTranslation2 = require("../../hooks/useTranslation/useTranslation");
var NotFound = function NotFound() {
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _notFoundModule.default['not-found']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _notFoundModule.default['not-found__message']
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: _notFoundModule.default['not-found__404']
  }, "404"), /*#__PURE__*/_react.default.createElement("i", {
    className: _notFoundModule.default['not-found__divider']
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: _notFoundModule.default['not-found__description']
  }, t('errors.pageNotFound'))));
};
exports.NotFound = NotFound;